import { Drawer as BlueprintDrawer } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { useVoiceboxSchema } from 'bones/components/molecules/Voicebox/context/VoiceboxSchema';
import { VoiceboxDrawerBody } from 'bones/components/molecules/Voicebox/VoiceboxDrawerBody';
import { VoiceboxDrawerButton } from 'bones/components/molecules/Voicebox/VoiceboxDrawerButton';

export const VoiceboxDrawer: React.VFC = () => {
  const {
    drawer: { isOpen, usePortal },
  } = useVoiceboxSchema();
  return (
    <div
      className={classNames('vb-voicebox-drawer-container', {
        'vb-voicebox-drawer-container--with-portal': usePortal,
      })}
    >
      {isOpen ? null : <VoiceboxDrawerButton />}
      <BlueprintDrawer
        canEscapeKeyClose={false}
        canOutsideClickClose={false}
        className="vb-voicebox-drawer"
        enforceFocus={false}
        hasBackdrop
        isOpen={isOpen}
        lazy={false}
        portalClassName="vb-voicebox-drawer-portal"
        portalContainer={
          (process.env.NODE_ENV === 'test' &&
            document.getElementById('vet-bones-root')) ||
          /* istanbul ignore next */ undefined
        }
        shouldReturnFocusOnClose={false}
        usePortal={usePortal}
      >
        <VoiceboxDrawerBody />

        {isOpen ? <VoiceboxDrawerButton /> : null}
      </BlueprintDrawer>
    </div>
  );
};
